import {
	CLEAR_FILEUPLOAD,
	FILE_SELECTING,
	FILE_UNSELECTING,
	FILE_UNSELECTING_ALL,
	FILE_UPLOADED,
	FILE_UPLOADING,
} from "../actions/types";
const initialState = {
	isSelected: false,
	isUploading: false,
	isUpLoaded: false,
	files: [],
	fileId: {},
};
export default function (state = initialState, action) {
	switch (action.type) {
		case FILE_SELECTING:
			return {
				...state,
				isUploading: false,
				isUpLoaded: false,
				isSelected: true,
				files: [
					...state.files,
					{ id: action.payload.id, file: action.payload.file },
				],
			};
		case FILE_UNSELECTING:
			console.log("FILE_UNSELECTING state.files=", state.files[0]);
			console.log("FILE_UNSELECTING action.payload=", action.payload);
			return {
				...state,
				isUploading: false,
				isUpLoaded: false,
				isSelected: true,
				files: state.files.filter(
					(x) => parseInt(x.id) !== parseInt(action.payload.id)
				),
			};
		case FILE_UNSELECTING_ALL:
			return {
				...state,
				isSelected: false,
				isUploading: false,
				isUpLoaded: false,
				files: [],
				fileId: {},
			};

		case FILE_UPLOADING:
			return {
				...state,
				isSelected: true,
				isUploading: true,
				isUpLoaded: false,
				fileId: {},
			};
		case FILE_UPLOADED:
			return {
				...state,
				isSelected: false,
				isUploading: false,
				isUpLoaded: true,
				fileId: action.payload,
			};
		case CLEAR_FILEUPLOAD:
			return {
				...state,
				isSelected: false,
				isUploading: false,
				isUpLoaded: false,
				file: null,
				fileId: {},
			};

		default:
			return state;
	}
}
